module.exports = __webpack_public_path__ + "static/media/manuel.567afa70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/manuel.png
// module id = 344
// module chunks = 0